import logo from './logo.svg';
import './App.css';
import AppRoutes from './components/AppRoutes';

function App() {
  return (
    <div className="App">
      <AppRoutes />
    </div>
  );
}

export default App;
